import React, { useState, useEffect } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import toast from 'react-hot-toast'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'

const EditCourseModal = ({ show, handleClose, course }) => {
  const [updatedCourse, setUpdatedCourse] = useState({
    course_name: '',
    duration: '',
    fee: '',
    description: '',
  })

  useEffect(() => {
    if (course) {
      setUpdatedCourse({
        course_name: course.name || '',
        duration: course.duration || '',
        fee: course.fee || '',
        description: course.description || '',
      })
    }
  }, [course])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setUpdatedCourse((prev) => ({ ...prev, [name]: value }))
    console.log(`Changed ${name} to: `, value)
    // setUpdatedCourse((prev) => ({
    //   ...prev,
    //   [name]: name === 'duration' ? String(value) : value,
    // }))
  }

  const handleSaveChanges = async () => {
    try {
      const response = await ApiEndpoints.editCourse(course.id, updatedCourse)
      toast.success(response.data.result)
      handleClose()
    } catch (error) {
      toast.error(error.response?.data?.result || 'Something wents wrong.')
    }
  }

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton className="bg-warning text-dark">
        <Modal.Title>Edit Course</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Course Name</Form.Label>
            <Form.Control
              type="text"
              name="course_name"
              value={updatedCourse.course_name}
              onChange={handleInputChange}
              placeholder="Enter Course Name"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Duration</Form.Label>
            <Form.Control
              type="tel"
              name="duration"
              value={updatedCourse.duration}
              onChange={handleInputChange}
              placeholder="Enter Duration"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Fee</Form.Label>
            <Form.Control
              type="text"
              name="fee"
              value={updatedCourse.fee}
              onChange={handleInputChange}
              placeholder="Enter Fee"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="description"
              value={updatedCourse.description}
              onChange={handleInputChange}
              placeholder="Enter Course Description"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="warning" onClick={handleSaveChanges}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default EditCourseModal
